import React, { useState, useEffect } from "react";
import deliveryImage from "../assets/DeliveryImage.jpg";
import storageImage from "../assets/StorageImage.jpg";
import produceImage from "../assets/ProductImage.jpg";
import productSourcingImage from "../assets/product-sourcing.jpg";
import personalShoppingImage from "../assets/product-shopping.jpg";

const OurServices: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 620);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 620);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const services = [
    {
      id: 1,
      title: "Reliable Nationwide And Cross-Border Delivery Solutions.",
      description:
        "We move goods efficiently—from parcels to pallets—across Nigeria and beyond, using a streamlined network of trusted partners and technologies to ensure timely arrivals every time.",
      image: deliveryImage,
      imageAlt: "Container loading and transportation logistics",
    },
    {
      id: 2,
      title: "Smart Storage That Scales With Your Business",
      description:
        "Our secure and strategically located warehouses allow for inventory management, order processing, and on-demand distribution, helping businesses cut costs and boost delivery speed",
      image: storageImage,
      imageAlt: "Modern warehouse storage facility",
    },
    {
      id: 3,
      title: "Connecting African Produce To Global Markets.",
      description:
        "We help local farmers and agro-processors reach international buyers with compliant, efficient, and temperature-controlled export logistics—ensuring quality from source to shelf.",
      image: produceImage,
      imageAlt: "Agricultural produce warehouse operations",
    }, {
      id: 4,
      title: "Personal Shopping Made Simple, Fast, and Global.",
      description: "We help shoppers access products from any store worldwide—handling purchase assistance, verified sourcing, international delivery, and customs clearance with end-to-end tracking. Secure, transparent, and reliable logistics that bring your desired items straight to your doorstep.",
      image: personalShoppingImage,
      imageAlt: "Personal Shopping Made Easy",
    },{
      id: 5,
      title: "Reliable Product Sourcing, Delivered Without Stress.",
      description:"We help businesses and individuals find trusted suppliers globally—handling verification, negotiation, quality checks, consolidation, and international delivery through our efficient logistics network. From sourcing to shipping, we ensure you get the right products at the right quality, delivered on time.",
      image: productSourcingImage,
      imageAlt: "Agricultural produce warehouse operations",
    },
  ];

  return (
    <section
      id="our-services"
      style={{
        paddingTop: isMobile ? "96px" : "140px",
        paddingLeft: isMobile ? "16px" : "64px",
        paddingRight: isMobile ? "16px" : "64px",
        backgroundColor: "#ffffff",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            marginBottom: "24px",
            textAlign: "left",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6B7280",
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              margin: "0 0 16px 0",
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            }}
          >
            OUR SERVICES
          </p>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: isMobile ? "48px" : "120px",
          }}
        >
          {services.map((service, index) => (
            <div
              key={service.id}
              style={{
                display: "flex",
                flexDirection: isMobile
                  ? "column"
                  : index % 2 === 0
                  ? "row"
                  : "row-reverse",
                alignItems: isMobile ? "stretch" : "flex-start",
                gap: isMobile ? "24px" : "96px",
              }}
            >
              <div
                style={{
                  flex: "1",
                  minHeight: isMobile ? "280px" : "400px",
                  borderRadius: "24px",
                  overflow: "hidden",
                  background: `url(${service.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    background:
                      "linear-gradient(45deg, rgba(0,0,0,0.05) 0%, rgba(255,138,0,0.05) 100%)",
                  }}
                />
              </div>

              <div
                style={{
                  flex: isMobile ? "1" : "none",
                  width: isMobile ? "100%" : "479px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  paddingTop: isMobile ? "0" : "24px",
                  textAlign: "left",
                }}
              >
                <h2
                  style={{
                    fontSize: isMobile ? "20px" : "32px",
                    fontWeight: "bold",
                    color: "#1a365d",
                    lineHeight: "1.3",
                    margin: "0 0 12px 0",
                  }}
                >
                  {service.title}
                </h2>

                <p
                  style={{
                    fontSize: isMobile ? "14px" : "16px",
                    color: "#4a5568",
                    opacity: "0.76",
                    lineHeight: "1.6",
                    margin: "0",
                  }}
                >
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurServices;
